module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-avatar-maker-67cae315.svg";